export const environment = {
  production: false,
  urlApi: 'https://dportal-api.wba.com.br',
  urlWS: 'https://dnew-websocket.wba.com.br/ws',
  keycloak: {
    url: 'https://homolog-auth.wba.com.br',
    realm: 'portal-demo',
    clientId: 'portal-angular'
  },
  gAnalytics: '203092816',
};
